import React from 'react';
import FooterTwo from '../../components/Footer/FooterTwo';
import HeaderTwo from '../../components/Header/HeaderTwo';
import HomeTwoMain from './HomeTwoMain';

const HomeTwo = () => {
  return (
    <>
      <HeaderTwo />
      <HomeTwoMain />
      <FooterTwo />
    </>
  );
};
export default HomeTwo;
